<template>
  <div class="item">
    <div class="item-img">
      <img :src="sortArr.pictureName" alt>
    </div>
    <div class="item-info">
      <p class="item-name">{{sortArr.foodName}}</p>
      <small class="item-alias">{{sortArr.foodAlias | formatAlias}}</small>
      <ul class="item-labels">
        <li v-for="(item,index) in sortArr.canEat" :key="index">
          <can-eat-label :num="item.show"></can-eat-label>
          {{item.crowd}}
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import CanEatLabel from "@/view/eating/components/can-eat-label";

export default {
  data() {
    return {};
  },
  name: "list-item",
  components: { CanEatLabel },
  props: ["data"],
  filters: {
    formatAlias: function(value) {
      return value && value.replace(/，/g, "、");
    }
  },
  computed: {
    sortArr() {
      let obj = this.data;
      obj.canEat.sort((a, b) => {
        return a.sort - b.sort;
      });
      return obj;
    }
  }
};
</script>
<style lang="less">
.item {
  display: flex;
  margin: 0 15px;
  border-bottom: 1px solid #e5e5e5;
  padding: 15px 0;
  height: 100px;
  box-sizing: border-box;
  &-img {
    width: 105px;
    height: 70px;
    border-radius: 6px;
    img {
      width: 100%;
      height: 100%;
      border-radius: 6px;
    }
  }
  &-info {
    margin-left: 17px;
    width: calc(100% - 122px);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  &-name {
    font-size: 18px;
    color: #222;
    margin: 0;
    font-family: PingFangSC-Regular;
    font-weight: 400;
  }
  &-alias {
    font-size: 11px;
    color: #999;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  &-labels {
    list-style: none;
    display: flex;
    font-size: 10px;
    color: #999;
    justify-content: space-between;
    padding-right: 4px;
    li {
      white-space: nowrap;
    }
  }
}
</style>

